/** IMPORT */
import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';

/** COMPONENT */
@Component({
    selector: 'app-modal-create-step',
    templateUrl: './modal-create-step.component.html',
    styles: []
})
/**
 * Klasse für die Initialisierung und Speicherung eines neuen Steps.<br>
 * @version Angular 7.0.0 <br>
 * @since 07.12.2022 <br>
 * xx.xx.xxxx wg. Evaluierung <br>
 * 07.12.2022 wg. Dokumentation <br>
 * @author Denny M. Lüdicke <br> E-Mail: denny.luedicke@excon.com <br>
 * Veränderungen von Denny M. Lüdicke
 */
export class ModalCreateStepComponent extends ExcTranslation  implements OnInit
{
      /** INPUT */
      @Input('enumarationStep') enumarationStep;

      /** ATTRIBUTE */
      enumeration: any[];
      sequence: any;
      data: any;
      addMore: false;
      selectedTyp: any;
      description: string;
      /** Die Beschreibungen der stID 12 und 18 */
      newDescription =
      {
          descriptionOne: '',
          descriptionTwo: '',
          descriptionThree: '',
          descriptionFour: '',
      }
      newCommit =
      {
          questionCommit: '',
          positiveCommit: '',
          negativeCommit: '',
      }

      /** Neue Step Variablen
       * PUT {uid}/selfcheckconfig/step
       * { ss_seqID: number, ss_stID: number, ssOrder: number, ssCaption: string, ssTip: string, ssInternalRemark: string?, ssImagesMin: number?, ssImagesMax: number?, ssSkipTo: number?}
       *
       * */
      newStep =
      {
          ss_seqID: 0,
          ss_stID: 0,
          ssOrder: 0,
          ssCaption: '',
          ssTip: '',
          ssInternalRemark: null,
          ssImagesMin: null,
          ssImagesMax: null,
          ssSkipTo: null,
      };


      constructor( public overlayConfig: OverlayConfig, public overlayRef: OverlayRef, private excSec: ExcSigninService )
      {
          super();
      }

      ngOnInit()
      {
          // console.log(this.overlayConfig);
          this.enumeration = this.overlayConfig.data.enumeration.Steps;
          this.sequence = this.overlayConfig.data.sequence;
          // this.showTrash();
          // console.log('ssORderNumber = ' + this.getSsOrderNumber());
      }

      /**
       * @param isAbort()
       */
      isAbort()
      {
          // console.log(this.overlayRef.close({proceed: true, auditor: 'hi'}));
          this.overlayRef.close();
      }
      /**
       * @param createNewStep()
       */
      createNewStep()
      {
          this.completeNewStep();
          let result = this.newStep;
          // console.log( result );
          // Object.assign( result,{stDescription: this.getMergeDescription()});
          this.overlayRef.close( result );
      }
      /**
       * @param selectedTypeChanged( event )
       */
      selectedTypeChanged(event)
      {
          this.selectedTyp = event;
          this.newStep.ss_stID = event;
      }
      /**
       * @param getStepTypCaption( any )
       */
      getStepTypCaption(stID: any)
      {
          return this.getRessource('StId_' + stID + '_Caption');
      }
      /**
       * @param tipInputChange( newTipValue, oldTipValue )
       */
      tipInputChange(newTipValue: any, oldTipValue: any)
      {
          // console.log(oldTipValue +' '+ newTipValue);
          this.sequence.ssTip = this.sequence.ssTip.replace(oldTipValue, newTipValue);
      }


      /** GETTER */
      /**
       * @param getFpsDescription()
       */
      getFpsDescription() :string
      {
          return  this.newDescription.descriptionOne + ';'
                + this.newDescription.descriptionTwo + ';'
                + this.newDescription.descriptionThree + ';'
                + this.newDescription.descriptionFour
      };
      /**
       * @param getCommitDescription()
       */
      getCommitDescription() : string
      {
          return  this.newCommit.questionCommit + ';'
                + this.newCommit.positiveCommit + ';'
                + this.newCommit.negativeCommit
      };
      /**
       * @param getSsOrderNumber()
       */
      getSsOrderNumber() : number
      {
          let ssOrderNumber = 0;
          for(let index of this.sequence.Steps)
          {
              ssOrderNumber++;
          };
          return ssOrderNumber +1;
      };
      /**
       * @param getSeqID()
       */
      getSeqID(): number
      {
          return this.sequence.seqID;
      }
      /**
       * @param completeDescription()
       */
      completeDescription()
      {
          if( this.newStep.ss_stID == 12 || this.newStep.ss_stID == 18 )
          {
              // console.log('12 oder 18');
              this.newStep.ssTip = this.getFpsDescription();

          }
          if( this.newStep.ss_stID == 14 )
          {
              // console.log('14');
              this.newStep.ssTip = this.getCommitDescription();
          }
          else
          {
              // console.log('normal');
          }
      }
      /**
       * @param completeNewStep()
       */
      completeNewStep()
      {
          this.newStep.ss_seqID = this.getSeqID();
          this.newStep.ssOrder = this.getSsOrderNumber();
          this.completeDescription();
      }
}
